import { api } from '../config/api';

export const ventasService = {
  // Obtener todas las ventas con paginación y filtros
  getVentas: async (params = {}) => {
    try {
      const data = await api.get('/api/ventas/', params);
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Obtener una venta por ID
  getVenta: async (id) => {
    try {
      const data = await api.get(`/api/ventas/${id}/`);
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Crear una nueva venta
  createVenta: async (ventaData) => {
    try {
      const data = await api.post('/api/ventas/', ventaData);
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Actualizar una venta
  updateVenta: async (id, ventaData) => {
    try {
      const data = await api.put(`/api/ventas/${id}/`, ventaData);
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Eliminar una venta
  deleteVenta: async (id) => {
    try {
      await api.delete(`/api/ventas/${id}/`);
      return { success: true };
    } catch (error) {
      throw error;
    }
  },

  // Obtener detalles de una venta
  getDetallesVenta: async (ventaId) => {
    try {
      const data = await api.get(`/api/ventas/${ventaId}/detalles/`);
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Anular una venta
  anularVenta: async (id, motivo) => {
    try {
      const data = await api.post(`/api/ventas/${id}/anular/`, { motivo });
      return data;
    } catch (error) {
      throw error;
    }
  },

  // Obtener estadísticas de ventas
  getEstadisticas: async (params = {}) => {
    try {
      const data = await api.get('/api/ventas/estadisticas/', params);
      return data;
    } catch (error) {
      throw error;
    }
  }
};

export default ventasService;

// Made with Bob
